import React from 'react';
import { useParams } from 'react-router-dom';

import AssignmentsRankingTable from '@ts-core/modules/rankings/components/AssignmentsRankingTable';
import RankingDatesRangePicker, { useRankingDatesRangePicker } from '../../components/RankingDatesRangePicker';

import { useAssignmentsRanking } from '../../hooks';

interface AssignmentsRankingPageProps {
  studentsMode?: boolean;
}

const AssignmentsRankingPage = (props: AssignmentsRankingPageProps) => {
  const { studentsMode } = props;

  const { courseId } = useParams<{ courseId: string }>();
  const { props: rankingDateRangePickerProps, from, to } = useRankingDatesRangePicker();

  const { loading, assignments, students, error, courseName, onRefetchRanking } = useAssignmentsRanking({ courseId, from, to });

  return (
    <AssignmentsRankingTable
      downloadFileName={courseName}
      getRankingByAssignments={onRefetchRanking}
      students={students}
      assignments={assignments}
      error={error}
      loading={loading}
      studentsMode={studentsMode}
      datesPicker={<RankingDatesRangePicker {...rankingDateRangePickerProps} />}
    />
  );
};

export default AssignmentsRankingPage;
